var _circle, _circle2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoadingAvatarDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#252A37"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4629_71062",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#EFF3F8"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4629_71062)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 49,
    r: 20,
    fill: "#373E51"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 19,
    r: 10,
    fill: "#373E51"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingAvatarDark);
export default __webpack_public_path__ + "static/media/loading-avatar-dark.26e7838b822b911722266b8e64cdb221.svg";
export { ForwardRef as ReactComponent };